import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconConfirm = ({ t, className, height, width, fill }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'
    width={width} height={height} viewBox='0 0 25 25'>
    <defs>
      <path id='a' d='M0 0h25v25H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='b'>
        <use xlinkHref='#a' />
      </mask>
      <use xlinkHref='#a' />
      <path fill={fill} d='M13.392 20.938a1.157 1.157 0 0 1 .02-1.658l3.282-3.046L6.35 6.002a1.157 1.157 0 0 1 0-1.658 1.21 1.21 0 0 1 1.69 0l11.2 11.07c.226.222.352.523.35.837a1.163 1.163 0 0 1-.36.832l-4.148 3.875a1.203 1.203 0 0 1-.835.334c-.31 0-.62-.118-.855-.354z'
        mask='url(#b)' transform='rotate(90 12.795 12.646)' />
    </g>
  </svg>
)

export default Icon(IconConfirm)
